<div class="main-content">
    <div class="main-header">
      <a [routerLink]="['/config-workbook/workbookcsv']" style="cursor: pointer;"><img
          src="./assets/Expand-Column-left.svg" alt="Image 1" class="r-m20" style="vertical-align: middle;" /></a>
      Workbook Templates <div class="tooltip"><img src="./assets/Info.svg" alt="Image 1" />
        <span class="tooltiptext">Workbook Templates For Workbook Extraction Process.</span></div>
    </div>
  
  
  
    <div class="section">
  
      <div class="content" style="margin: 15px 16px 0px">
        <p class="text_16_b" style="display: inline-block;margin-top: 10px;">Workbook Templates For Workbook Extraction Process</p>
      </div>
      <div class="content" style="margin: 0px 16px;padding-bottom: 10px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
        <div style="display: inline-block; padding-right: 20px;">
          <div class="checkOptions">
            <mat-checkbox style="cursor: pointer;" [checked]="selectAllVal" (change)="selectAll($event)">
              <span style="color:#333333">Select all</span>
            </mat-checkbox>
          </div>
        </div>       
       
        <div style="float: right;">
          <button mat-flat-button class="green-button" (click)="downloadTemplates()"
          style="float: right;margin-left: 40px;margin-top: 10px;min-width: 120px;"> Download Templates </button>
        </div>
      </div>
  
  
      <div class="content" style="margin: 0px 16px 32px 16px;">
        <div *ngFor="let item of tracks; let i = index" class="tracks-class">
          <span (click)="showArray[i]=!showArray[i]"><span *ngIf="!showArray[i]"><img src="./assets/Expand-Column.svg"
                class="expand-button" alt="Expand-Column"></span>
            <span *ngIf="showArray[i]"><img src="./assets/Expand-Column-svg.svg"
                class="expand-button" alt="Expand-Column"></span><button mat-button>{{item}}</button>
          </span>
          <div *ngIf="showArray[i]">
            <mat-radio-group [(ngModel)]="moduleName">
              <div *ngFor="let configItem of configData; let i= index">
                <ng-container class="b-spacing container" *ngIf="item === configItem.TRACK">
                  <div class="item" style="width:50%; float:left">
                    <mat-checkbox  [checked]="configItem.saveStatus"
                      [disableRipple]="true" class="example-radio-button"
                      (change)="onChange($event,configItem,item)" [value]="configItem.APPLICATION"
                      type="Checkbox">{{configItem.APPLICATION}}
                    </mat-checkbox>
                  </div>
                </ng-container>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
  
    </div>
  </div>
  